import { formatDateTime, groupStatusLabel, JOB_STATE_LABEL } from "../utils/parsers";

// Every video registered on the selected day, one row per file with a chip
// per job. "Process again" is offered once no job of the file is queued or
// running: finished, failed and stopped videos alike.
export default function VideoList({ groups, status, error, date, onReprocess, busyKey }) {
  return (
    <div className="video-list" data-testid="video-list">
      <div className="video-list-title">
        Videos registered on {date || "today"}
        {status === "ready" ? ` (${groups.length})` : ""}
      </div>

      {status === "loading" && <p className="status-text">Loading videos...</p>}
      {status === "error" && (
        <p className="status-text error">Could not load videos: {error}</p>
      )}
      {status === "ready" && groups.length === 0 && (
        <p className="status-text">No videos registered on this day.</p>
      )}

      {groups.length > 0 && (
        <table className="video-table">
          <thead>
            <tr>
              <th>Video</th>
              <th>Jobs</th>
              <th>Status</th>
              <th>Uploaded</th>
              <th>Finished</th>
              <th aria-label="Actions"></th>
            </tr>
          </thead>
          <tbody>
            {groups.map((group) => (
              <tr key={group.key} className={`video-row ${group.status}`}>
                <td className="video-name">{group.name}</td>
                <td>
                  {group.jobs.map((job) => (
                    <span
                      key={job.id}
                      className={`chip state-${job.state}`}
                      title={job.error ?? JOB_STATE_LABEL[job.state]}
                    >
                      {job.asset_type ?? "job"}
                      {job.state === "processing" ? ` ${job.progress}%` : ""}
                    </span>
                  ))}
                </td>
                <td>
                  <span className={`status-pill ${group.status}`}>
                    {groupStatusLabel(group)}
                  </span>
                </td>
                <td>{formatDateTime(group.createdOn)}</td>
                <td>{formatDateTime(group.finishedOn)}</td>
                <td>
                  {group.canReprocess && (
                    <button
                      type="button"
                      className="reprocess-btn"
                      disabled={busyKey === group.key}
                      onClick={() => onReprocess(group)}
                    >
                      {busyKey === group.key ? "Queuing..." : "Process again"}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
